import React from 'react';
import styled from 'styled-components';

/**
 * Badge 컴포넌트 Props
 * @typedef {Object} BadgeProps
 * @property {string} [text=''] - 뱃지에 표시할 텍스트
 * @property {string} [backColor='gray'] - 배경색
 * @property {string} [color='#fff'] - 텍스트 색상
 * @property {boolean} [outlined=false] - 아웃라인 스타일 여부
 */

/* 사용 색상 : #AFD83F, #3FD5FF, #E124C7, #FF7B63 */
const Badge = ({ text = '', backColor = 'gray', color = '#fff', outlined = false }) => {
  return (
    <StyledBadge $backColor={backColor} $color={color} $outlined={outlined}>
      {text}
    </StyledBadge>
  );
};

const StyledBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: ${(p) => (p.$outlined ? '#fff' : p.$backColor)};
  color: ${(p) => p.$color};
  border: ${(p) => (p.$outlined ? `1px solid ${p.$color}` : 'none')};
`;

export default Badge;
